import { useHref, useLocation } from 'react-router-dom';

const useRootHref = (to) => {
  const location = useLocation();
  const basename = useHref('/').slice(0, -1);
  const backSteps =
    location.pathname.split('').filter((c) => c === '/').length + basename.split('').filter((c) => c === '/').length;
  const pathBackSteps = '/..'.repeat(backSteps);
  return `${pathBackSteps}${to}`;
};

export default useRootHref;
